// URL utilities
// Provides shared helpers for API base and backend origin resolution

export const getApiBase = () => (import.meta.env.VITE_API_BASE_URL || '/api/')

export const getBackendOrigin = () => getApiBase().replace(/\/?api\/?$/, '')
